import { Create, Edit } from 'react-admin';
import { default as icon } from '@mui/icons-material/Person';
import { FormFields } from './components';
import list from './list';

export const create = () => (
	<Create>
		{FormFields}
	</Create>
);

export const edit = () => (
	<Edit mutationMode="pessimistic">
		{FormFields}
	</Edit>
);

export const User = {
	list, edit, create, icon
};

export default User;